import { createSlice } from '@reduxjs/toolkit'

export interface Report {
  ken_details: {
    ken_number: string
    account_number: string
    contract_number: string
    functional_location_id: string
    functional_location_name: string
  }[]
  report_setting_id: string
  is_service_order: boolean
}
// Initial state
const initialState = {
  report: {
    ken_details: [],
    report_setting_id: '',
    is_service_order: false,
  } as unknown as Report,
  loading: false,
  error: null as string | null,
}

const createReportSlice = createSlice({
  name: 'createReportSlice',
  initialState,
  reducers: {
    updateReport(state, action) {
      console.log('state.filters', action.payload)
      const { type, data } = action.payload

      if (type === 'KEN_DETAILS') {
        state.report.ken_details = data
      }
      if (type === 'REPORT_SETTING') {
        state.report.report_setting_id = data
      }
      if (type === 'IS_SERVICE_ORDER') {
        state.report.is_service_order = data
      }
      console.log('state.filters', state.report)
    },
  },
})

export const { updateReport } = createReportSlice.actions
export default createReportSlice.reducer
